var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetencyFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.188 19.627v-4.6l3.732-1.947v4.6l-3.732 1.947zm0-10.377l3.732-1.898V12l-3.732 1.899V9.25zm-4.222-3.142l3.732-1.899 4.108 1.899-3.781 1.997-4.059-1.997zM8.22 3.784L12 2l3.781 1.735-3.78 1.882L8.22 3.784zm-1.294 4.32L3.195 6.158 7.188 4.26l3.78 1.833-4.042 2.013zM6.812 13.9L3.08 12V7.352L6.812 9.25v4.65zm0 5.728l-3.732-1.9V13.13l3.732 1.899v4.599zm9.493-6.023l-3.732-1.899V7.057l3.732 1.899v4.648zM11.46 22l-3.732-1.898v-4.583l3.732 1.898V22zm.54-9.59l4.059 2.045L12 16.615l-4.059-2.16L12 12.409zm-.605-.54l-3.732 1.898V9.119l3.732-1.898v4.648zm4.877 8.232L12.54 22v-4.599l3.732-1.899v4.6z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetencyFill);
export default __webpack_public_path__ + "748889b910c7060b3b719c35bbe01340.svg";
export { ForwardRef as ReactComponent };